module.exports = __webpack_public_path__ + "static/media/who-4.5df0f31b.jpg";